import { useAppSelector } from 'hooks';
import { useCallback } from 'react';
import { AppDispatch } from 'redux/store';
import { GadgetEditModel } from 'types/entity';
import { useDispatch } from 'react-redux';
import { gadgetUpdateQuery } from './gadget-update.selector';
import { gadgetUpdateActions } from './gadget-update.slice';

export const useGadgetUpdateFacade = () => {
  const dispatch: AppDispatch = useDispatch();

  /** ロード済みか */
  const loaded = useAppSelector(gadgetUpdateQuery.getLoaded);
  /** 編集中か */
  const touched = useAppSelector(gadgetUpdateQuery.getTouched);
  /** ガジェット一覧 */
  const gadgets: GadgetEditModel[] = useAppSelector(gadgetUpdateQuery.getEntities);
  /** 選択中のガジェット */
  const selectedGadget: GadgetEditModel | undefined = useAppSelector(gadgetUpdateQuery.getSelectedEntity);

  /** ガジェット追加、更新 */
  const upsertGadget = useCallback(
    (gadget: GadgetEditModel) => dispatch(gadgetUpdateActions.upsert(gadget)),
    [dispatch],
  );
  /** 複数ガジェットの追加、更新 */
  const upsertManyGadget = useCallback(
    (_gadgets: GadgetEditModel[]) => dispatch(gadgetUpdateActions.upsertMany(_gadgets)),
    [dispatch],
  );
  /** 複数ガジェットの削除 */
  const removeManyGadget = useCallback(
    (gadgetIds: string[]) => dispatch(gadgetUpdateActions.removeMany(gadgetIds)),
    [dispatch],
  );
  /** ガジェット選択 */
  const selectGadget = useCallback(
    (gadget_id: string) => dispatch(gadgetUpdateActions.selectOne(gadget_id)),
    [dispatch],
  );
  /** 編集中を解除する */
  const unTouched = useCallback(
    () => dispatch(gadgetUpdateActions.unTouched()),
    [dispatch],
  );

  return {
    loaded,
    touched,
    gadgets,
    selectedGadget,
    upsertGadget,
    upsertManyGadget,
    removeManyGadget,
    selectGadget,
    unTouched,
  };
};
